export default __webpack_public_path__ + "static/media/cebios-logo.11fbb72e.png";